import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";

export default function Footer() {
  const { t } = useI18n();
  const { user } = useAuth();
  return (
    <footer className="border-t-2 border-ink bg-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div>
            <div className="font-cabinet font-extrabold text-2xl">GetFluent<span className="text-coral">Loop</span></div>
            <p className="text-sm text-gray-600 max-w-xs mt-2">
              {t("footer.tagline")}
            </p>
            <p className="text-xs text-gray-400 mt-3" data-testid="footer-eu">{t("footer.eu")}</p>
          </div>
          <div className="flex gap-12">
            <div>
              <div className="nb-tag bg-mint mb-3">{t("footer.product")}</div>
              <ul className="space-y-2 text-sm font-medium">
                <li><Link to="/app" className="hover:text-coral">LanguageLoop</Link></li>
                <li><Link to="/education" className="hover:text-coral" data-testid="footer-for-schools">{t("footer.forSchools")}</Link></li>
                {!user && <li><Link to="/login" className="hover:text-coral" data-testid="footer-signin">{t("footer.signIn")}</Link></li>}
                {!user && <li><Link to="/signup" className="hover:text-coral" data-testid="footer-get-started">{t("footer.getStarted")}</Link></li>}
              </ul>
            </div>
            <div>
              <div className="nb-tag bg-lavender mb-3">{t("footer.legal")}</div>
              <ul className="space-y-2 text-sm font-medium">
                <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-coral">{t("footer.privacy")}</Link></li>
                <li><Link data-testid="footer-terms" to="/terms" className="hover:text-coral">{t("footer.terms")}</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-6 text-xs text-gray-400 flex flex-wrap justify-between gap-2">
          <span data-testid="footer-studio">© {new Date().getFullYear()} GetFluentLoop · <span className="font-medium text-gray-500">Felix Lancelot studios</span></span>
          <span dir="ltr">getfluentloop.com</span>
        </div>
      </div>
    </footer>
  );
}
